import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { closeSummary } from '@carvana/purchase-store';
import { withDocumentTitle, routeTo } from '@carvana/purchase-helpers';
import { withAnalytics } from '@carvana/analytics';
import {
  getDashboardSteps,
  getPurchaseExperiments,
  getDashboardOrderSummary,
  getPaymentSummary,
  getPurchaseHeaderExperiment
} from 'Components/dashboard/ducks/selectors';
import * as DashboardActions from 'Components/dashboard/ducks/actions';
import Summary from './order-summary';

const mapStateToProps = state => ({
  steps: getDashboardSteps(state),
  experiments: getPurchaseExperiments(state),
  orderSummary: getDashboardOrderSummary(state),
  paymentSummary: getPaymentSummary(state),
  isInPurchaseHeaderExperiment: getPurchaseHeaderExperiment(state)
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ ...DashboardActions, closeSummary, routeTo }, dispatch);

export default compose(
  withRouter,
  withDocumentTitle('Dashboard Summary'),
  withAnalytics({
    componentName: 'Dashboard Summary',
    enableComponentTracking: true
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(Summary);
